import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { FinishBlock } from "./styled";
import stars from "../../resources/images/main/stars_bg.png";
import { MainBlock } from "../Main/styled";
import mobileBg from "../../resources/images/main/mobile_bg.png";
import { Container, Heading, Text } from "../../styled";
import logo from "../../resources/images/main/logo_finish.svg";
import congrats from "./../../resources/images/main/congrats.png";
import Button from "../design_components/Button/Button";
import { useSelector } from "react-redux";
import {
  createEventObjectFunction,
  redirectToStoreFunction,
} from "../../utils/helper";
import { storeOpenEventAmplitude } from "../../amplitude/events";
import { storeOpenEvent } from "../../firebaseAnalytics/events";
import { analytics } from "../../firebaseAnalytics";
import { greyTextColor } from "../../constants/colors";

const Finish = () => {
  const history = useHistory();

  const [isOpacity, setOpacity] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setOpacity(false);
    }, 1500);
  }, []);

  const storeLink = useSelector(
    (state) => state.questions.remoteConfig.storeLink
  );
  const landingId = useSelector((state) => state.questions.landingId);

  const handleButtonClick = () => {
    const eventObj = createEventObjectFunction(null, null, landingId);
    // Событие №6 store open
    storeOpenEvent(analytics, eventObj);
    storeOpenEventAmplitude(eventObj);
    redirectToStoreFunction();
    window.location.href = storeLink;
  };

  return (
    <MainBlock isFinish={true} style={{ opacity: 1 }}>
      <img className="stars" src={stars} alt="stars" />
      <Container.Content>
        <MainBlock.Wrapper>
          <MainBlock.Top>
            <MainBlock.Top.Logo style={{ marginBottom: 45 }}>
              <img src={logo} alt="logo" style={{ margin: "0 auto" }} />
            </MainBlock.Top.Logo>

            <FinishBlock.Img>
              <img style={{ width: 250 }} src={congrats} alt="" />
            </FinishBlock.Img>
            <div style={{ position: "relative", zIndex: 3 }}>
              <Heading
                style={{
                  marginBottom: 16,
                  zIndex: 2,
                  position: "relative",
                }}
                className={"finish"}
              >
                <span>Congratulations!</span>
              </Heading>
              <Text.Third
                style={{ marginBottom: 10, zIndex: 2, position: "relative" }}
              >
                <span style={{ color: greyTextColor }}>
                  You’re now a member <br />
                  of Journey{" "}
                </span>
                <span className={"premium"}>premium</span>
              </Text.Third>
            </div>
          </MainBlock.Top>
          <MainBlock.Bottom>
            <Button
              type={"default"}
              isGradient={true}
              text={"Install Journey"}
              action={() => handleButtonClick()}
            />
            <FinishBlock.Gradient
              style={{ transition: "0.5s", opacity: isOpacity ? 0 : 1 }}
            />
          </MainBlock.Bottom>
        </MainBlock.Wrapper>
      </Container.Content>
    </MainBlock>
  );
};

export default Finish;
